import React from "react";

import Sidebar from "../components/ui/Sidebar";
import Topbar from "../components/ui/Topbar";
import Breadcrumbs from "../components/ui/Breadcrumbs";
import LoadingSpinner from "../components/ui/LoadingSpinner";
import { WORKSPACE_TYPES } from "../config/navigation";
import { colors, layout, spacing } from "../components/ui/theme";
import { useUser } from "../contexts/UserContext";

export default function WorkspaceLayout({
  children,
  workspaceType = WORKSPACE_TYPES.INTERNAL,
  title = "Ecovanta Workspace",
  subtitle = "AI Sustainability Intelligence Platform",
  breadcrumbs = [],
  user: userOverride
}) {
  const { user, loadingUser } = useUser();

  const activeUser = userOverride || user;

  return (
    <div style={appShellStyle}>
      <Sidebar workspaceType={workspaceType} user={activeUser} />

      <div style={mainShellStyle}>
        <Topbar title={title} subtitle={subtitle} user={activeUser} />

        <main style={contentStyle}>
          {breadcrumbs.length > 0 && <Breadcrumbs items={breadcrumbs} />}

          {loadingUser ? (
            <LoadingSpinner label="Loading workspace..." />
          ) : (
            children
          )}
        </main>
      </div>
    </div>
  );
}

const appShellStyle = {
  minHeight: "100vh",
  background: colors.background
};

const mainShellStyle = {
  marginLeft: layout.sidebarWidth,
  minHeight: "100vh"
};

const contentStyle = {
  padding: spacing["2xl"]
};